import { IgButton } from "@intelligems/ig-theme/IgButton";

import { RuleExperiencesDialog } from "../rules/RuleExperiencesDialog";

/**
 * "Keep this rule?" — Back on a rule Atlas just created in this chat, before
 * any experience uses it (ENG-7894, Figma 15183:9889). Creating it already
 * saved it as a draft, so the choice is whether it stays.
 */
export const RuleKeepDraftDialog = ({
  open,
  ruleName,
  isDeleting,
  onClose,
  onDelete,
  onKeep,
}: {
  open: boolean;
  ruleName: string;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
  onKeep: () => void;
}) => (
  <RuleExperiencesDialog
    open={open}
    title="Keep this rule?"
    description={`${ruleName} is saved as a draft under Rules, but it isn't used in any experiences yet.`}
    experiences={[]}
    onClose={onClose}
    maxWidth="sm"
    actions={
      <>
        <IgButton
          color="secondary"
          size="small"
          loading={isDeleting}
          onClick={onDelete}
        >
          Delete rule
        </IgButton>
        <IgButton
          color="primary"
          size="small"
          disabled={isDeleting}
          onClick={onKeep}
        >
          Keep as draft
        </IgButton>
      </>
    }
  />
);
